import React, { ReactElement, useContext } from 'react';
import { theming as surveyTheming } from '@sm/webassets';
import { t } from '@sm/intl';
import { Box } from '@wds/box';
import { createUseStyles } from 'react-jss';
import COPY from '~app/pages/EnterpriseThankYou/copy';
import Logo from './components/Logo';
import Text from './components/Text';
import { HeaderPropsType, HeaderTypeEnum } from './types';
import { PageVariants, EnterpriseThankYouContext } from '~app/pages/EnterpriseThankYou';

const useStyles = createUseStyles({
  headerOutline: {
    paddingBottom: 0,
    '@media (max-width: 479px)': {
      paddingBottom: 40,
    },
  },
});

const Header = ({ headerLogoUrl, headerText }: HeaderPropsType): ReactElement => {
  const { pageVariant } = useContext(EnterpriseThankYouContext);
  const { logo: surveyLogo } = useContext(surveyTheming.context);
  const premiumCustom = pageVariant === PageVariants.premiumCustom;
  const { headerOutline } = useStyles();

  const headerType = premiumCustom ? HeaderTypeEnum.PREMIUM : HeaderTypeEnum.STANDARD;
  const defaultSurveyLogoUrl = surveyLogo?.image?.url;
  const url = premiumCustom ? headerLogoUrl : defaultSurveyLogoUrl;

  const logo = {
    url: url ?? '',
    altText: t(COPY.LOGO_PLACEHOLDER),
  };

  return (
    <Box className={headerOutline}>
      <Logo headerType={headerType} altText={logo.altText} url={logo.url} />
      <Text text={headerText} headerType={headerType} />
    </Box>
  );
};

export default Header;
